import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import PageSection from './PageSection';

import { addUtils } from './class-name-helpers';

export const LASERS_BANNER_IMAGE = 'https://images.ctfassets.net/gtqjh9j40j4m/2QFaRapDaMAjKdaJ3fo6YJ/b3d7ea49ca30fcfe774ceeb1984afe75/5ffd8144a7409cd29c512446_lasers.svg';

const LaserBannerPageSection = ({ children, ...rest }) => {
  const className = clsx(addUtils(rest).utilClassNames);

  return (
    <PageSection banner center backgroundImage={{ url: LASERS_BANNER_IMAGE }} className={className}>
      {children}
    </PageSection>
  );
};

LaserBannerPageSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LaserBannerPageSection;
